<div *ngIf="apiService.supplierRole"
  class="role">
  {{apiService.Notautorized}}
</div>
<div *ngIf="!apiService.supplierRole">
<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <section id="Noprop" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 section">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4 pl-0">
        <button type="button" class="btn btn-green btn-custom btn-blue mr-2 btn-ht testing" [routerLink]="['/bvd']"
          *ngIf="showForConsult">
          <mat-icon  class="img-btn img-btn-md" svgIcon="add-2"></mat-icon>
          <span class="float-right">Import a Supplier</span>
        </button>
      </div>
      <div class="center col-4 text-center"> <img class="logo"
          src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png" alt="edit"></div>
      <div class="col-4 text-right">
        <div> <app-helpsection></app-helpsection></div>
      </div>
    </div>
  </section>
  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 search-panel">
    <app-suppliertab></app-suppliertab>
    <div class="row m-0 align-center">
      <div class="col col-12 col-sm-8 col-md-9 col-lg-9 col-xl-9">
        <h4 class="title">SEARCH</h4>
      </div>
      <div class="col col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3">
        <button type="button" class="btn btn-custom btn-darkred float-right testing crgrp" data-toggle="modal"
          data-target="#createGroupModalPopup" (click)="updateCreateGroupExistsName()" *ngIf="roleVariableHide" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (updateCreateGroupExistsName())">
          <mat-icon class="icon" svgIcon="add-2"></mat-icon>
          <span class="float-right group"> Create Group </span>
        </button>
      </div>
    </div>
    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <mat-label class="label-control">Group name
        </mat-label>
        <div style="position: relative; width: 100%;">
          <input
            type="text"
            class="form-control"
            style="width: 100%; height: 33px; padding: 6px 12px; font-size: 14px;"
            [formControl]="userQuestionUpdate2"
            (keyup)="onItemKey($event)"
            (keydown.enter)="getChangeHandler(1); $event.preventDefault()"
            (keydown)="$event.key !== 'Enter' && resetSelectedFields('identifierValueModellabel')"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" class="groupName-autocomplete display">
            <ng-container *ngIf="supplierNameNewDropDown.length > 0; else noResults">
              <mat-option class="drop" *ngFor="let name of supplierNameNewDropDown"
                (onSelectionChange)="setidentifierNameModel(name)" [value]="name">
                <span>{{ name }}</span>
              </mat-option>
            </ng-container>
            <ng-template #noResults>
              <mat-option class="noResults" disabled
                *ngIf="supplierNameModel.length >= minlength && !autoload">
                <span>No results</span>
              </mat-option>
            </ng-template>
          </mat-autocomplete>
          <small class="search-close-btn" title="Clear"><button
              class="no-border" (click)="resetSelectedFields('supplierNameModellabel')">X</button></small>
          <small class="search-close-btn cls" *ngIf="autoload"><img
              src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
        </div>
      </div>
    </div>
    <div class="row m-0 ml-3 align-center">
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
      <span class="px-2 font-weight-bold">OR</span>
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
    </div>
    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 pb-0 mb-0">
        <mat-label class="label-control">Identifier Type</mat-label>
        <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="identifierTypeModel"
          (selectionChange)="onIdentifierTypeChange($event.value)" panelClass="dropdown-panel" [disableOptionCentering]="true">
          <mat-option *ngFor="let groupIdentifierKey of groupIdentifierKeys"
            value="group-identifiers$${{groupIdentifierKey.row_id}}">{{groupIdentifierKey.name.replace('MDM
            GROUP','Group code')}} </mat-option>
          <mat-option value="groups">Group ID</mat-option>
          <mat-option value="category">Group Category</mat-option>
          <mat-option value="status">Group Status</mat-option>
        </mat-select>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mt-3">
        <label for="IdentifierValueFLag" class="label-control">Identifier Value
        </label>
        <div style="position: relative; width: 100%;" *ngIf="!categoryDropdown && !statusDropdown">
          <input
            type="text"
            class="form-control"
            style="width: 100%; height: 33px; padding: 6px 12px; font-size: 14px;"
            [formControl]="userQuestionUpdate"
            (keydown.enter)="getChangeHandler(1); $event.preventDefault()"
            (keydown)="$event.key !== 'Enter' && resetSelectedFields('supplierNameModellabel')"
            (keyup)="onItemKey($event)"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete display">
            <ng-container *ngIf="supplieriDvalDropDown.length > 0 && enterKey; else noResults">
              <mat-option class="drop" *ngFor="let value of supplieriDvalDropDown"
                (onSelectionChange)="onIdentivalueSelect(value)" [value]="value">
                <span>{{ value }}</span>
              </mat-option>
            </ng-container>
            <ng-template #noResults>
              <mat-option class="noResults" disabled
                *ngIf="identifierValueModel.length >= minlength && !autoload1 && enterKey">
                <span>No results</span>
              </mat-option>
            </ng-template>
          </mat-autocomplete>
          <small class="search-close-btn" title="Clear"><button
             class="no-border" (click)="resetSelectedFields('identifierValueModellabel')">X</button></small>
          <small class="search-close-btn" *ngIf="autoload1"><img src="assets/images/loading.gif"
              class="loadingheight" alt="Updating..."></small>
        </div>
        <div class="pr-4 m-0" *ngIf="categoryDropdown">
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="identifierValueModel"
            panelClass="dropdown-panel"
            [disableOptionCentering]="true">
            <mat-option *ngFor="let category of groupCategories" [value]="category.groupTypeCode">{{category.groupTypeCode}}</mat-option>
          </mat-select>
        </div>
        <div class="pr-4 m-0" *ngIf="statusDropdown">
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="identifierValueModel"
            panelClass="dropdown-panel"
            [disableOptionCentering]="true">
            <mat-option *ngFor="let status of groupStatuses" [value]="status.value">{{status.displayName}}</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right search-actions"
        *ngIf="!roleVariableHide">
        <mat-label class="label-control hidden"> &nbsp; </mat-label>
        <button type="button" class="btn btn-custom btn-link" (click)="resetSelectedFields('')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields(''))"> Clear All </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue" (click)="getChangeHandler(1)"> Search
        </button>
      </div>
    </div>
    <div class="row m-0 align-center search-actions-row">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right search-actions" *ngIf="roleVariableHide">
        <button type="button" class="btn btn-custom btn-link" (click)="resetSelectedFields('')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields(''))"> Clear All </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue" (click)="getChangeHandler(1)"> Search
        </button>
      </div>
    </div>
  </section>
  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <div class="row m-0 pt-3 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">RESULTS <span *ngIf="listFlag==true && data && data.length>=0">({{pagedTotalItem}})</span>
        </h4>
      </div>
      <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
        <button type="button" class="btn btn-custom btn-purple float-right expo" *ngIf="superUserShow">
          <mat-icon svgIcon="download" class="thick-icon exp"></mat-icon><span class="float-right"> Export </span>
        </button>
      </div>
    </div>
    <div class="row m-0">
      <div class="table-responsive mt-3">
        <div [ngClass]="{ 'fixTableHead' :listFlag == true, 'fixTableFoot' :listFlag == true }">
          <table class="table table-sm m-0">
            <thead>
              <tr>
                <th class="sortDecorationunderline" (click)="sort('groupname')" (keydown.enter)="sort('groupname')"
                   (keydown.space)="sort('groupname')" class="grpname" tabindex="0">Group Name</th>
                <th class="grpsh">Group Short Name</th>
                <th class="sortDecorationunderline grpst" (click)="sort('groupstatus')"
                  (keydown.enter)="sort('groupstatus')" (keydown.space)="sort('groupstatus')" tabindex="0">Status</th>
                <th class="sortDecorationunderline grpst" (click)="sort('alliancegroupid')" (keydown.enter)="sort('alliancegroupid')"
                (keydown.space)="sort('alliancegroupid')" tabindex="0">Group Id</th>
                <th *ngIf="showForSupplier" class="grpsh" (click)="sort('bvdid')" (keydown.enter)="sort('bvdid')"
                 (keydown.space)="sort('bvdid')" tabindex="0">BvD ID</th>
                <th class="sortDecorationunderline grpst" (click)="sort('groupcategory')" (keydown.enter)="sort('groupcategory')"
                (keydown.space)="sort('groupcategory')" tabindex="0">Group Category</th>
              </tr>
            </thead>
            <tbody *ngIf="listFlag == true && data && data.length>0">
              <tr *ngFor="let supplierDataList of data | orderBy: key:reverse">
                <td class="font-weight-bold label-darkblue"><a class="label-darkblue"
                    [routerLink]="['/supplier-group-details',supplierDataList.groupIds]">{{supplierDataList.groupname}}</a>
                </td>
                <td>
                  <span *ngIf="groupShortNameVal[supplierDataList.groupIds]">
                    {{groupShortNameVal[supplierDataList.groupIds].value}}
                  </span>
                </td>
                <td><span class="group-status"
                    *ngIf="supplierDataList.groupstatus !='' && supplierDataList.groupstatus!=undefined"
                    [ngStyle]="{'background':getColor(supplierDataList.groupstatus)}">
                  {{supplierDataList.groupstatus.replace('VALIDATED','ACTIVE').replace("PENDING_VALIDATION","PENDING").replace("ACTIVE","Active")}}</span></td>
                <td>{{supplierDataList.alliancegroupid}}</td>
                <td *ngIf="showForSupplier"><span
                    *ngIf="bvdAccToGrpIden[supplierDataList.representingCompanyId]">
                    {{bvdAccToGrpIden[supplierDataList.representingCompanyId].value}}</span>
                </td>
                <td>{{supplierDataList.groupcategory}}</td>
              </tr>
            </tbody>
            <tbody *ngIf="!data || data.length==0">
              <tr>
                <td colspan="6" *ngIf="showForSupplier" class="font-weight-bold text-center text-darkblue"> No records
                  found.</td>
                <td colspan="5" *ngIf="!showForSupplier" class="font-weight-bold text-center text-darkblue"> No records
                  found.</td>
              </tr>
            </tbody>
            <tfoot *ngIf="listFlag == true && data && data.length>0">
              <tr>
                <td colspan="6">
                  <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="getChangeHandler(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getChangeHandler(1))">First</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="getChangeHandler(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getChangeHandler(pager.currentPage - 1))">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                      <a (click)="getChangeHandler(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getChangeHandler(page))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="getChangeHandler(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getChangeHandler(pager.currentPage + 1))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="getChangeHandler(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getChangeHandler(pager.totalPages))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tfoot>
            <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
          </table>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="modal fade" id="createGroupModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel1">
          Create Group by <span class="label-blue">ADMIN</span>
          <button type="button" class="close" id="closeGCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="groupNameId">Group Name<span class="element_astrick">*</span>
            </label>
            <input type="text" [attr.maxLength]="maxGrpNameLength" id="groupNameId" class="form-control form-control-sm"
              [(ngModel)]="groupNameModel"
              (keyup)="checkvalidateGroupNameRegField(groupNameModel,'groupNameModel','groupNameModelError','groupNameModelRegExError')"
              (ngModelChange)="groupNameModel = $event.toUpperCase()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                class="ng-clear cancel" (click)="resetGrouNameFields()" (keydown.enter)="resetGrouNameFields()"
                (keydown.space)="resetGrouNameFields()" tabindex="0">×</button></span>
            <span class="ctg" *ngIf="groupNameModelError==true">Please enter group name</span>
            <span class="ctg" *ngIf="groupNameModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="groupShortName">Group Short Name<span class="element_astrick">*</span>
            </label>
            <input type="text" maxlength="6" id="groupShortName" class="form-control form-control-sm"
              [(ngModel)]="groupShortName"
              (keyup)="checkvalidateGroupNameRegField(groupShortName,'groupShortName','groupShortNameError','groupShortNameRegExError')"
              (ngModelChange)="groupShortName = $event.toUpperCase()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                class="ng-clear cancel" (click)="resetGroupShortNameFields()" (keydown.enter)="resetGroupShortNameFields()"
                (keydown.space)="resetGroupShortNameFields()" tabindex="0">×</button></span>
            <span class="ctg" *ngIf="groupShortNameError==true">Please enter group short name</span>
            <span class="ctg" *ngIf="groupShortNameRegExError==true">A-Z 0-9 space () . , - /</span>
            <span class="ctg" *ngIf="groupShortNameExistsError==true">This identifier value exists already.
              Please enter different value.</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label class="label-control">Group Category<span class="element_astrick">*</span>
            </mat-label>
            <div>
              <mat-select class="form-control form-control-sm dropdown-select" *ngIf="groupCategories.length>0"
                [(ngModel)]="groupCategoryModel" (selectionChange)="checkvalidateGroupCategoryField()"
                panelClass="dropdown-panel" [disableOptionCentering]="true">
                <mat-option *ngFor="let groupCategory of groupCategories"
                  value="{{groupCategory.row_id}}">{{groupCategory.groupTypeCode}}</mat-option>
              </mat-select>
              <mat-select class="form-control form-control-sm dropdown-select" *ngIf="groupCategories.length<=0"
                [(ngModel)]="groupCategoryModel" panelClass="dropdown-panel" [disableOptionCentering]="true">
                <mat-option value="">&nbsp;</mat-option>
              </mat-select>
              <span class="ctg" *ngIf="groupCategoryModelError==true">Please select group category</span>
            </div>
            <div *ngIf="groupCategories.length<=0">
              <img src="assets/images/loading.gif" alt="loading...">
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveGroupDetails()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon> <span class="float-right"> {{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="showConfirmStartBatchOnStart" tabindex="-1" aria-modal="true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Set GR Batch
          <button type="button" class="close" id="closeGRStartBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">
              <span>
                Previously the batch was paused at page : <span
                  class="label-orange font-weight-bold">{{grBatchPageHolder}}</span>
              </span>
            </div>
            <div class="py-2">
              <span>
                Batch processing resumes in :<span class="font-weight-bold pl-1"
                  class="page">{{timerForBatchStart}}</span>
              </span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal" (click)="stopGRBatchAssnExe()">
            Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="showGRBatch" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel2">
          Set GR Batch
          <button type="button" class="close" id="closeGRBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="showDownloadLog==false">&nbsp;
              <span [innerHtml]="grTextDisp">
              </span>
            </div>
            <div class="py-2" *ngIf="showDownloadLog==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFile()">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-orange">Processing page:</span>&nbsp;<span class="page">{{pageBatchNo}}</span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" (click)="changeStopBatch()"> Stop </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="showAlreadyRunBatch" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel3">
          Set GR Batch
          <button type="button" class="close" id="closeGRBatchExistDia" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">&nbsp;
              <span>
                Previously the batch was stopped at page : <span
                  class="label-orange font-weight-bold">{{grBatchPageHolder}}</span>
              </span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button class="btn btn-custom btn-blue start" data-dismiss="modal"
            (click)="setGRBatchFn(grBatchPageHolder,'continue',20)"> Continue From {{grBatchPageHolder}}</button>
          <button class="btn btn-custom btn-blue ctn" data-dismiss="modal"
            (click)="setGRBatchFn(1,'continue',20)"> Start Over</button>
          <button type="button" class="btn btn-custom btn-blue ctn" data-dismiss="modal"> Cancel
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="showSelectCountryId" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content" class="country">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel4">
          Select Country
          <button type="button" class="close" id="closeshowSelectCountryId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-select class="form-control" name="countrySelect" id="" [(ngModel)]="selectedCustomCountry">
              <mat-option value="{{coun}}" *ngFor="let coun of countrySelList">{{coun}}</mat-option>
            </mat-select>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="checkSelRunSite()"> OK </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="batch">
  <table id="excelTableLog">
    <thead>
      <tr>
        <th>Group Name</th>
        <th>Group ID</th>
        <th>Representing Company ID</th>
        <th>Representing Company Identifier</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of tableDataForSetGRBatch">
        <td>
          {{c.name ? c.name : '-'}}
        </td>
        <td>
          {{c.allianceIdentifier ? c.allianceIdentifier : '-'}}
        </td>
        <td>
          {{c.representingCompanyId ? c.representingCompanyId : '-'}}
        </td>
        <td>
          {{c.representingCompanyAllianceIdentifier ? c.representingCompanyAllianceIdentifier : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="batch">
  <button id="btnForGRContinue" data-target="#showAlreadyRunBatch" data-toggle="modal"></button>
  <button id="btnForGRBatch" data-target="#showGRBatch" data-toggle="modal"></button>
  <button id="BtnForshowConfirmStartBatchOnStart" data-target="#showConfirmStartBatchOnStart"
    data-toggle="modal"></button>
  <button id="btnForSelectCountryId" data-target="#showSelectCountryId" data-toggle="modal"></button>
</div>
</div>